import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function ProductIntro() {
  return <section className="bg-[#0A0A0A] px-5 py-16 md:py-24" data-id="element-205">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-206">
        <motion.p variants={itemVariants} className="text-[#E8732A] text-sm md:text-base font-medium tracking-wide uppercase mb-4" data-id="element-207">
          Presentando
        </motion.p>

        <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-208">
          Vistas <span className="text-[#E8732A]" data-id="element-209">≠</span> Ventas
        </motion.h2>

        <motion.p variants={itemVariants} className="text-xl md:text-2xl text-[#A0A0A0] mb-10" data-id="element-210">
          Toolkit de Conversión para Afiliados en 7 Días
        </motion.p>

        <motion.div variants={itemVariants} className="bg-[#141414] p-6 md:p-8 rounded-lg border border-[#2A2A2A] mb-10" data-id="element-211">
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-4" data-id="element-212">
            Este PDF <span className="text-white font-semibold" data-id="element-213">NO</span> es
            motivación.
          </p>
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-4" data-id="element-214">
            No es "mentalidad".
          </p>
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-6" data-id="element-215">
            No es "hazte viral".
          </p>
          <p className="text-white text-xl md:text-2xl font-semibold leading-relaxed" data-id="element-216">
            Es un <span className="text-[#E8732A]" data-id="element-217">kit operativo</span> para
            reparar tu conversión con cambios pequeños:
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-218">
          <motion.div variants={itemVariants} className="flex items-center gap-3" data-id="element-219">
            <span className="text-[#E8732A]" data-id="element-220">→</span>
            <p className="text-[#A0A0A0] text-lg" data-id="element-221">frases exactas</p>
          </motion.div>
          <motion.div variants={itemVariants} className="flex items-center gap-3" data-id="element-222">
            <span className="text-[#E8732A]" data-id="element-223">→</span>
            <p className="text-[#A0A0A0] text-lg" data-id="element-224">CTAs con palabra clave</p>
          </motion.div>
          <motion.div variants={itemVariants} className="flex items-center gap-3" data-id="element-225">
            <span className="text-[#E8732A]" data-id="element-226">→</span>
            <p className="text-[#A0A0A0] text-lg" data-id="element-227">flujo de DM de 4 mensajes</p>
          </motion.div>
          <motion.div variants={itemVariants} className="flex items-center gap-3" data-id="element-228">
            <span className="text-[#E8732A]" data-id="element-229">→</span>
            <p className="text-[#A0A0A0] text-lg" data-id="element-230">
              pruebas "seguras" para cursos (sin claims peligrosos)
            </p>
          </motion.div>
          <motion.div variants={itemVariants} className="flex items-center gap-3" data-id="element-231">
            <span className="text-[#E8732A]" data-id="element-232">→</span>
            <p className="text-[#A0A0A0] text-lg" data-id="element-233">
              plan de 7 días para estabilizarlo
            </p>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}